<template>
    <div class="projects-wrap products-wrap">
        <div class="projects-header products-header">
            <h3 class="title-with-dot">Products</h3>
        </div>

        <div class="projects-list products-list">
            <project-item className="product" iconName="la-arrow-right" :item="product" v-for="(product, i) in products" :key="i" />
        </div>
    </div>
</template>

<script>
import ProjectItem from '../modules/ProjectItem.vue';

export default {
    name: 'ProductsSection',
    components: {
        ProjectItem
    },
    data() {
        return {
            products: [
                {
                    img: require('@/assets/images/project1.jpg'),
                    title: 'Seven Studio'
                },
                {
                    img: require('@/assets/images/project2.jpg'),
                    title: 'Raven Studio'
                },
                {
                    img: require('@/assets/images/me.png'),
                    title: 'Ohilo'
                }
            ]
        }
    }
}
</script>